import React, { useState } from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/SudokuBasics.css';
import SudokuVsVideo from './SudokuVsVideo';
import SudokuGameRules from './SudokuGameRules';
import { useLanguage } from 'Core/Translations/LanguageContext';
import { scrollToTop } from '../../ScrollToTop'; 
interface SudokuGameRulesControllerProps {
    onClose: () => void;
}

export const SudokuGameRulesController: React.FC<SudokuGameRulesControllerProps> = ({ onClose }) => {
    const { t } = useLanguage();
    const [currentStep, setCurrentStep] = useState(1);

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return <SudokuVsVideo />;
            case 2:
                return <SudokuGameRules />;
            default:
                return <SudokuVsVideo />;
        }
    };

    const handleNextClick = () => {
        if (currentStep < 2) {
            setCurrentStep(currentStep + 1);
            scrollToTop();
        } else {
            // When on the final step, call onClose
            onClose();
            scrollToTop();
        }
    };

    return (
        <div className="tutorial-container">
            <div className="main-content">
                {renderStep()}
            </div>

            <footer className="footer">
                <div className="button-container">
                    <button
                        className="navigation-button"
                        onClick={() => {
                            setCurrentStep(Math.max(1, currentStep - 1));
                            scrollToTop();
                        }}
                        disabled={currentStep === 1}
                    >
                        {t.beginnersGuide.controller.previous}
                    </button>
                    <span className="progress-indicator">
                        {currentStep}{t.beginnersGuide.controller.of}2
                    </span>
                    <button
                        className="navigation-button"
                        onClick={handleNextClick}
                    >
                        {currentStep === 2 ? t.beginnersGuide.controller.close : t.beginnersGuide.controller.next}
                    </button>
                </div>
            </footer>
        </div>
    );
};

export default SudokuGameRulesController;